import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/index.vue'),
    meta: {
      title: '搜机网',
      index: 0
    }
  },
  {
    path: '/guide/index',
    name: 'GuideIndex',
    component: () => import('@/views/guide/index.vue'),
    meta: {
      title: '搜机网-App下载',
      index: 2
    }
  },
  {
    path: '/agreement/privacy',
    name: 'Privacy',
    component: () => import('@/views/agreement/privacy.vue'),
    meta: {
      title: '搜机网-隐私协议',
      index: 1
    }
  },
  {
    path: '/agreement/user',
    name: 'UserAgreement',
    component: () => import('@/views/agreement/user.vue'),
    meta: {
      title: '搜机网-用户协议',
      index: 1
    }
  },
  {
    path: '/agreement/pay',
    name: 'PayAgreement',
    component: () => import('@/views/agreement/pay.vue'),
    meta: {
      title: '搜机网-支付协议',
      index: 1
    }
  },
  {
    path: '/agreement/logoff',
    name: 'Logoff',
    component: () => import('@/views/agreement/logoff.vue'),
    meta: {
      title: '搜机网-账户注销协议',
      index: 1
    }
  },
  {
    path: '/agreement/wallet',
    name: 'WalletAgreement',
    component: () => import('@/views/agreement/wallet.vue'),
    meta: {
      title: '搜机网-钱包服务协议',
      index: 1
    }
  },
  {
    path: '/cms/banner',
    name: 'CMSBanner',
    component: () => import('@/views/cms/banner.vue'),
    meta: {
      title: '搜机网',
      index: 1
    }
  },
  {
    path: '/cms/titlebar',
    name: 'CMSTitlebar',
    component: () => import('@/views/cms/titlebar.vue'),
    meta: {
      title: '搜机网',
      index: 1
    }
  },
  {
    path: '/cms/video',
    name: 'CMSVideo',
    component: () => import('@/views/cms/video.vue'),
    meta: {
      title: '搜机网',
      index: 1
    }
  },
  {
    path: '/order/upload',
    name: 'OrderUpload',
    component: () => import('@/views/orders/index.vue'),
    meta: {
      title: '搜机网',
      index: 1
    }
  },
  {
    path: '/order/flow',
    name: 'OrderFlow',
    component: () => import('@/views/orderFlow/index.vue'),
    meta: {
      title: '订单流程',
      index: 1
    }
  },
  {
    path: '/health',
    name: 'Health',
    component: () => import('@/views/health/index.vue'),
    meta: {
      title: '健康检查',
      index: 0
    }
  },
  {
    path: '/promotionRank',
    name: 'PromotionRank',
    component: () => import('@/views/promotionRank/index.vue'),
    meta: {
      title: '推广英雄榜 - 搜机网',
      index: 1
    }
  },
  {
    path: '/:inviteToken',
    name: 'Regitry',
    component: () => import('@/views/user/registry.vue'),
    meta: {
      title: '搜机网-用户注册',
      index: 1
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router
